import './virtualFocus.css';
export var virtualFocus = {neutral:'_9mvxlq0-3-15-1',primary:'_9mvxlq1-3-15-1'};